import { useQuery } from '~src/services/client';
import { fetchAddressSuggestions } from '~src/utilities/addressHelper';
import { deepNullToUndefined } from '~src/utilities/convert';

import { useToastMessageErrorHandler } from '../useToastMessage';

// Provider outages are toasted; an empty list means the provider found no match.
export const useDawaAddressSuggestions = (searchAddress: string) => {
  const { data, isLoading } = useQuery(
    ['dawaAddressSuggestions', searchAddress],
    ({ signal }) => fetchAddressSuggestions(searchAddress, { signal }),
    {
      enabled: searchAddress?.length > 2,
      onError: useToastMessageErrorHandler(),
      retry: 1,
    }
  );

  return { suggestions: deepNullToUndefined(data) ?? [], isLoading };
};
